import { render, staticRenderFns } from "./NewFolderModal.vue?vue&type=template&id=5319eaca&"
import script from "./NewFolderModal.vue?vue&type=script&lang=ts&"
export * from "./NewFolderModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports